export default __webpack_public_path__ + "static/media/folder.f7e17625.svg";